import React from 'react';
import { useTranslation } from 'react-i18next';

import { SewBillingCycleRangeExport } from '@/backoffice/features/data-exports/sew-billing-cycle-range-export/sew-billing-cycle-range-export';
import { useLazySewInternalCostCenterExportQuery } from '@/backoffice/redux/api/billing-backoffice/billing-backoffice-api';
import { FileDownloadIcon } from '@/shared/assets/icons/file-download-icon';

export const SewInternalCostCenterExport = () => {
  const { t } = useTranslation();
  const [getFile] = useLazySewInternalCostCenterExportQuery();

  const fetchExport = async (
    startBillingCycleReferenceTs: number,
    endBillingCycleReferenceTs: number,
  ) => {
    const response = await getFile({
      startBillingCycleReferenceTs,
      endBillingCycleReferenceTs,
    }).unwrap();
    return response?.sewInternalCostCenterExport;
  };

  return (
    <SewBillingCycleRangeExport
      icon={<FileDownloadIcon />}
      title={t('backoffice:sew.data_exports.internal_cost_center.title')}
      description={t(
        'backoffice:sew.data_exports.internal_cost_center.description',
      )}
      loaderText={t(
        'backoffice:sew.data_exports.internal_cost_center.loader_text',
      )}
      baseFileNamePrefix="sew_internal_cost_center_export"
      fetchExport={fetchExport}
    />
  );
};
